import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "self-stretch pb-1 flex-col justify-start items-start gap-2 flex" }
const _hoisted_2 = { class: "self-stretch justify-start items-center gap-3 inline-flex" }
const _hoisted_3 = { class: "grow shrink basis-0 text-racq-dark-grey text-lg-bold" }
const _hoisted_4 = { class: "self-stretch flex-col justify-start items-start gap-4 flex" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = ["onClick"]

import { useFormStore } from '@/store';
import { IReviewSummary } from '@/interfaces';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';
import ReviewSummaryItem from '@/components/ReviewSummary/ReviewSummaryItem.vue';
import BaseIcon from '@/components/BaseIcon/BaseIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdditionalPeople',
  props: {
    summaries: {}
  },
  setup(__props: any) {



const formStore = useFormStore();

const goToStep = (uuid: string) => {
  formStore.goToStepUsingUUID(uuid);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaries, (summary, index) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["self-stretch px-8 pt-8 pb-4 border-racq-pale-blue-border border-t flex-col justify-start items-start gap-4 flex", index === _ctx.summaries.length - 1 ? '' : 'border-b'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (summary.icon?.value)
            ? (_openBlock(), _createBlock(BaseIcon, {
                key: 0,
                iconClass: summary.icon?.value
              }, null, 8, ["iconClass"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Text), {
              field: summary.summaryTitle
            }, null, 8, ["field"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.items, (item, itemIndex) => {
          return (_openBlock(), _createBlock(ReviewSummaryItem, {
            key: itemIndex,
            item: item,
            isLastReviewSummaryItem: itemIndex === summary.items.length - 1
          }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(RichText), {
                  field: item.title,
                  class: "text-racq-dark-grey text-base-bold"
                }, null, 8, ["field"])
              ])
            ]),
            content: _withCtx(() => [
              _createVNode(_unref(RichText), {
                field: item.content,
                class: "text-base text-block"
              }, null, 8, ["field"])
            ]),
            edit: _withCtx(() => [
              (item.editUrl != null && item.showEdit)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "link text-base-bold",
                    onClick: ($event: any) => (goToStep(item.editUrl))
                  }, " Edit ", 8, _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["item", "isLastReviewSummaryItem"]))
        }), 128))
      ])
    ], 2)), [
      [_vShow, summary.items.length]
    ])
  }), 128))
}
}

})